import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import type { ItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes';

const DumbRoundedAvatar = ({ image }: { image: ItemAttributes }) => {
  const { alt: imageAlt, url: imageUrl, hidden } = image.attributes;

  if (hidden) {
    return null;
  }

  return (
    // Surrounding with a box in order for the with to be fixed
    <Box>
      <StyledImage $image={imageUrl}>
        {imageAlt && <span role="img" aria-label={imageAlt} />}
      </StyledImage>
    </Box>
  );
};

export default DumbRoundedAvatar;

const StyledImage = styled(Box).attrs({
  width: { xl: 104, l: 104, m: 48, _: 48 },
})<{ $image: ItemAttributes }>`
  background-image: ${({ $image }) => `url(${$image})`};
  background-repeat: no-repeat;
  background-size: cover;
  object-fit: cover;
  border-radius: 50%;
  &:after {
    content: '';
    display: block;
    padding-bottom: 100%;
  }
`;
